'use strict';

const EXCLUDED_RDT_COOKIE_PATH_KEYWORDS = [ 'subscription', 'sign-in', 'signin', 'login' ];

function getFirstPathSegment( pathname ) {
    return pathname.split( '/' ).filter( Boolean )[0] || '';
}

function isExcludedRdtCookiePath( pathname ) {
    const firstPathSegment = getFirstPathSegment( pathname );
    return EXCLUDED_RDT_COOKIE_PATH_KEYWORDS.some( function( keyword ) {
        return firstPathSegment.indexOf( keyword ) !== -1;
    } );
}

function shouldSetRdtCookie( body ) {
    return !body.classList.contains( 'ignore-rdt' ) &&
        !body.classList.contains( 'login-page' ) &&
        !body.classList.contains( 'registration-page' ) &&
        !isExcludedRdtCookiePath( window.location.pathname );
}

function getPathname( url ) {
    try {
        return new URL( url, window.location.origin ).pathname;
    } catch ( e ) {
        return null;
    }
}

function resolveRdtUrl() {
    const rdtQueryString = getParameterByName( 'rdt' );
    let rdtUrl;

    if ( rdtQueryString && rdtQueryString.indexOf( 'learning:' ) !== -1 ) {
        rdtUrl = rdtQueryString + '&source=' + getParameterByName( 'source' );
    } else {
        rdtUrl = Cookies.get( 'aw_rdt_url' ) || 'https://www.adweek.com/';
    }

    rdtUrl = rdtUrl.split( '?' )[0];
    if ( rdtUrl.indexOf( '#' ) > 0 ) {
        rdtUrl = rdtUrl.split( '#' )[0];
    }

    return rdtUrl;
}

function updateLoginRegisterLinks( rdtUrl ) {
    const loginRegisterLinks = [
        document.getElementById( 'subscriber-login' ),
        document.getElementById( 'header-subscribe-link' ),
        document.querySelector( '#aw_create_account > a' )
    ].filter( Boolean );

    loginRegisterLinks.forEach( function( link ) {
        const oldLinkURL = link.getAttribute( 'href' );
        const newLinkURL = oldLinkURL + ( oldLinkURL.indexOf( '?' ) === -1 ? '?' : '&' ) + 'rdt=' + encodeURI( rdtUrl );
        link.setAttribute( 'href', newLinkURL + '?ntfData=login' );
    } );
}

function isCurrentLoginPage() {
    if ( typeof window.adw === 'undefined' || typeof window.adw.account_login_url === 'undefined' ) {
        return false;
    }

    const loginUrlPath = getPathname( window.adw.account_login_url );
    return loginUrlPath !== null && loginUrlPath === window.location.pathname;
}

function redirectToRdtUrlIfNeeded() {
    if ( typeof window.awZephrUserData === 'undefined' || window.awZephrUserData.firstName === undefined ) {
        return;
    }

    if ( !isCurrentLoginPage() ) {
        return;
    }

    const rdtUrl = getParameterByName( 'rdt' ) || Cookies.get( 'aw_rdt_url' );

    if ( !rdtUrl ) {
        return;
    }

    const rdtUrlPath = getPathname( rdtUrl );

    if ( rdtUrlPath !== null && rdtUrlPath !== window.location.pathname ) {
        window.location.href = rdtUrl;
    }
}

window.addEventListener( 'load', function() {
    const body = document.body;

    if ( shouldSetRdtCookie( body ) ) {
        Cookies.set( 'aw_rdt_url', window.location.href, { expires: 365 } );
    }

    const rdtUrl = resolveRdtUrl();
    updateLoginRegisterLinks( rdtUrl );
} );

document.addEventListener( 'DOMContentLoaded', redirectToRdtUrlIfNeeded );
